import { render } from "./ChevronRight.svg?vue&type=template&id=514a1fc0"
const script = {}
script.render = render

export default script